module.exports = __webpack_public_path__ + "img/LK.b8655245.png";